/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './common';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "UsBusiness": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ein": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": ".squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "einFideliusToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.onboarding.business.UsBusiness.Type",
                    "id": 7,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 8,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "physicalAddressToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "registeredAddressToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": ".squareup.common.location.Phone",
                    "id": 13,
                    "rule": "optional"
                  },
                  "runVerificationAfter": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "registeredAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 15,
                    "rule": "optional"
                  },
                  "tradingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 16,
                    "rule": "optional"
                  },
                  "mobileBusiness": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "BUSINESS": 1,
                      "INDIVIDUAL": 2,
                      "LIMITED_COMPANY": 3,
                      "LIMITED_LIABILITY_COMPANY": 4,
                      "PARTNERSHIP": 5,
                      "PUBLIC_COMPANY": 6,
                      "OTHER": 7,
                      "CHARITABLE_NON_PROFIT": 8,
                      "COMPANY": 9,
                      "KYB_LIMITED_COMPANY": 10,
                      "KYB_LIMITED_LIABILITY_COMPANY": 11,
                      "KYB_PARTNERSHIP": 12,
                      "KYB_PUBLIC_COMPANY": 13,
                      "KYB_OTHER": 14,
                      "KYB_COMPANY": 15,
                      "KYB_CHARITABLE_NON_PROFIT": 16,
                      "INDIVIDUAL_SOLE_TRADER": 17,
                      "SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": 18
                    }
                  }
                }
              },
              "UsState": {
                "values": {
                  "US_STATE_UNKNOWN": 0,
                  "AL": 1,
                  "AK": 2,
                  "AS": 3,
                  "AZ": 4,
                  "AR": 5,
                  "CA": 6,
                  "CO": 7,
                  "CT": 8,
                  "DE": 9,
                  "DC": 10,
                  "FL": 11,
                  "GA": 12,
                  "GU": 13,
                  "HI": 14,
                  "ID": 15,
                  "IL": 16,
                  "IN": 17,
                  "IA": 18,
                  "KS": 19,
                  "KY": 20,
                  "LA": 21,
                  "ME": 22,
                  "MD": 23,
                  "MA": 24,
                  "MI": 25,
                  "MN": 26,
                  "MS": 27,
                  "MO": 28,
                  "MT": 29,
                  "NE": 30,
                  "NV": 31,
                  "NH": 32,
                  "NJ": 33,
                  "NM": 34,
                  "NY": 35,
                  "NC": 36,
                  "ND": 37,
                  "MP": 38,
                  "OH": 39,
                  "OK": 40,
                  "OR": 41,
                  "PA": 42,
                  "PR": 43,
                  "RI": 44,
                  "SC": 45,
                  "SD": 46,
                  "TN": 47,
                  "TX": 48,
                  "UT": 49,
                  "VT": 50,
                  "VA": 51,
                  "VI": 52,
                  "WA": 53,
                  "WV": 54,
                  "WI": 55,
                  "WY": 56
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.UsBusiness && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.UsBusiness?.nested?.Type && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.UsState) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in the US.
 *
 * SOURCE UsBusiness @ squareup/onboarding/business/us.proto at 13:1
 */
export const UsBusiness = $root.lookupType('squareup.onboarding.business.UsBusiness');
fixType(UsBusiness);
Builder.createAndAttachToType(UsBusiness);
/**
 * SOURCE Type @ squareup/onboarding/business/us.proto at 53:3
 */
UsBusiness.Type = $root.lookupEnum('squareup.onboarding.business.UsBusiness.Type').values;
/**
 * source: https://www.ssa.gov/international/coc-docs/states.html
 *
 * SOURCE UsState @ squareup/onboarding/business/us.proto at 77:1
 */
export const UsState = $root.lookupEnum('squareup.onboarding.business.UsState').values;